import React from 'react';
import { LocaleContext } from '../providers/LocaleProvider';

const useLocale = () => React.useContext(LocaleContext);

export default useLocale;
